import { getArchiveGoals,getUserGoal,
} from '../api/userGoalApi';
import UserGoalCard from '../usercomponents/UserGoalCard';
import { getGoalChecks } from '../api/userGoalCheckApi';
import { useEffect, useState, useRef } from 'react';

import { useGoalActions } from '../hooks/useGoalActions';


function Archived() {
  const [archivedGoals, setArchivedGoals] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openGoals, setOpenGoals] = useState({});
  const [goalDetails, setGoalDetails] = useState({});
  const [goalCheckDates, setGoalCheckDates] = useState({});
  const [entryInputs, setEntryInputs] = useState({});
  const [viewedMonths, setViewedMonths] = useState({});

  const loadingGoalLock = useRef({});

const { handleRenameGoal,handleDeleteGoal,handleUpdateCategory, handleToggleArchive,
  handleViewGoal, handleChangeEntryInput, handleAddEntry, handleDeleteEntry,
  handleRenameEntry,loadGoalDetails,handleMonthNav
  } 
= useGoalActions({
  setGoals: setArchivedGoals,setGoalDetails,setGoalCheckDates,setOpenGoals,
  setViewedMonths,setEntryInputs,entryInputs, loadingGoalLock
});


  
  useEffect(() => {
    const fetchAndRestore = async () => {
      try {
        setIsLoading(true);
        const res = await getArchiveGoals();
        setArchivedGoals(res.data);

        const saved = localStorage.getItem('archivedOpenGoals');
        if (saved) {
          const parsed = JSON.parse(saved);
          setOpenGoals(parsed);

          // Load details only for goals that actually exist
          for (const goalId of Object.keys(parsed)) {
            if (parsed[goalId]) {
              await loadGoalDetails(goalId); // fetch details after goal exists
            }
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAndRestore();
  }, []);

  
  const loadArchivedGoals = async () => {
    try {
      setIsLoading(true);
      const res = await getArchiveGoals();
      setArchivedGoals(res.data);
    } catch (err) {
      console.error('Error loading archived goals:', err);
    } finally {
      setIsLoading(false);
    }
  };

 


  if (isLoading) return <p>Loading archived goals...</p>;

  return (
    <div className="app-container">
      <h1>Archived Goals</h1>
      {archivedGoals.length === 0 ? (
        <p>No archived goals yet.</p>
      ) : (
        <ul className="goal-list">
          {archivedGoals.map((goal) => (
            <li key={goal.id}>
              <UserGoalCard
                goal={goal}
                onView={() => handleViewGoal(goal.id, 'archivedOpenGoals', loadGoalDetails)}
                isOpen={openGoals[goal.id]}
                selectedGoal={goalDetails[goal.id]}
                checkDates={goalCheckDates[goal.id] || []}
                onDelete={() => handleDeleteGoal(goal.id, loadArchivedGoals)}
                onRename={(id, title) => handleRenameGoal(id, title)}
               onToggleArchive={handleToggleArchive}
                isArchived={true}
                newEntryDescription={entryInputs[goal.id] || ''}
                onChangeNewEntry={(text) => handleChangeEntryInput(goal.id, text)}
                onAddEntry={() => handleAddEntry(goal.id)}
                onDeleteEntry={(entryId) => handleDeleteEntry(goal.id, entryId )}
                onRenameEntry={(entryId, text) => handleRenameEntry(goal.id, entryId, text)}
                viewedMonth={viewedMonths[goal.id]}
              onUpdateCategory={handleUpdateCategory}
              onPrevMonth={() => handleMonthNav(goal.id, 'PREV')}
              onNextMonth={() => handleMonthNav(goal.id, 'NEXT')}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default Archived;
